(function () {
  const sections = document.querySelectorAll(".ingredients-list--desktop");
  if (!sections.length) return;

  function initSection(section) {
    const rule = section.querySelector(".ingredients-list__rule");
    const description = section.querySelector(".ingredients-list__description");
    const items = [...section.querySelectorAll(".ingredients-list__item")];
    if (!rule || !description || items.length === 0) return;

    let activeItem = null;
    setActive(items[0]);

    function setActive(item) {
      if (item === activeItem) return;

      activeItem?.classList.remove("active");
      activeItem?.removeAttribute("aria-current");
      item.classList.add("active");
      item.setAttribute("aria-current", "true");
      activeItem = item;

      description.textContent = item.dataset.description;

      const itemRect = item.getBoundingClientRect();
      const sectionRect = section.getBoundingClientRect();
      rule.style.transform = `translateY(${itemRect.top - sectionRect.top}px)`;
      rule.style.marginLeft = `${itemRect.left - sectionRect.left}px`;
    }

    items.forEach((item) => {
      item.setAttribute("tabindex", "0");
      item.addEventListener("mouseenter", () => setActive(item));
      item.addEventListener("focus", () => setActive(item));
    });
  }

  for (const section of sections) {
    initSection(section);
  }
})();
